import { Skeleton } from '@cobliteam/ui/components';

const GeofenceDetailsSkeleton = () => {
  return (
    <div className='relative flex h-[500px] w-full flex-col gap-4 overflow-hidden overflow-y-auto p-4'>
      {/* Header Skeleton */}
      <div className='flex items-start gap-3'>
        <Skeleton className='h-10 w-10 rounded-lg' />
        <div className='flex-1 space-y-2'>
          <Skeleton className='h-5 w-48' />
          <Skeleton className='h-4 w-64' />
        </div>
      </div>

      {/* Details Skeleton */}
      <div className='grid grid-cols-12 gap-2'>
        <div className='col-span-6'>
          <div className='mb-1 flex items-center gap-2 font-medium text-xs'>
            <Skeleton className='h-5 w-48' />
          </div>
          <div className='ml-5 w-full space-y-2'>
            <Skeleton className='h-3 w-20' />
          </div>
        </div>

        <div className='col-span-6'>
          <div className='mb-1 flex flex-1 items-center gap-2 font-medium text-xs'>
            <Skeleton className='h-5 w-48' />
          </div>
          <div className='ml-5 w-full space-y-2'>
            <Skeleton className='h-3 w-24' />
          </div>
        </div>
      </div>

      {/* Map Skeleton */}
      <div className='flex-1 space-y-3'>
        <div className='flex items-center justify-between'>
          <Skeleton className='h-4 w-48' />
          <Skeleton className='h-8 w-8 rounded' />
        </div>
        <Skeleton className='h-64 w-full rounded-lg' />
        <div className='flex items-center justify-between text-muted-foreground text-xs'>
          <Skeleton className='h-3 w-32' />
          <Skeleton className='h-3 w-20' />
        </div>
      </div>
    </div>
  );
};

export default GeofenceDetailsSkeleton;
